import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { CardMedia } from "@/components/CardImage";
import { ConditionBadge, Tag } from "@/components/Badges";
import { Loading, ErrorState } from "@/components/States";
import { ProposalComposer } from "@/components/ProposalComposer";
import { Button } from "@/components/ui/button";
import { ArrowLeftRight, Send, Info } from "lucide-react";

function Column({ title, tone, items }) {
  return (
    <div className="rounded-2xl border border-[#2A3655] bg-[#141B2D] p-4">
      <h3 className="mb-3 font-display font-semibold" style={{ color: tone }}>{title} ({items.length})</h3>
      {items.length === 0 ? <p className="text-sm text-[#94A3B8]">Nessuna carta.</p> : (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {items.map((a) => (
            <div key={a.id} className="rounded-lg border border-[#2A3655] bg-[#0B1020] p-1.5">
              <CardMedia photos={a.photos} card={a.card} />
              <p className="mt-1 line-clamp-1 px-0.5 text-xs font-semibold text-[#F8FAFC]">{a.card?.name}</p>
              <div className="flex flex-wrap gap-1 px-0.5 pb-0.5"><ConditionBadge value={a.condition} /><Tag>{a.language}</Tag><Tag tone="#94A3B8">×{a.available_qty}</Tag></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function MatchDetail() {
  const { userId } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [open, setOpen] = useState(false);

  const load = () => { setError(null); api.get(`/matches/${userId}`).then((r) => setData(r.data)).catch(() => setError("Impossibile caricare il match.")); };
  useEffect(() => { load(); }, [userId]);

  if (error) return <ErrorState message={error} onRetry={load} />;
  if (!data) return <Loading />;

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h1 className="font-display text-2xl font-bold text-[#F8FAFC]">Corrispondenze con <Link to={`/collezionista/${data.user.username}`} className="text-[#2DD4BF] hover:underline">@{data.user.username}</Link></h1>
          <div className="mt-2 flex flex-wrap gap-2 text-sm">
            <span className="rounded-md border border-[#2DD4BF]/30 bg-[#2DD4BF]/10 px-2 py-0.5 font-semibold text-[#2DD4BF]">Hai {data.you_can_give.length} {data.you_can_give.length === 1 ? "carta" : "carte"} che cerca</span>
            <span className="rounded-md border border-[#7C3AED]/30 bg-[#7C3AED]/10 px-2 py-0.5 font-semibold text-[#a78bfa]">Ha {data.you_can_receive.length} {data.you_can_receive.length === 1 ? "carta" : "carte"} che cerchi</span>
          </div>
        </div>
        <Button onClick={() => setOpen(true)} data-testid="open-proposal" className="bg-[#7C3AED] hover:bg-[#6D28D9]"><Send className="mr-2 h-4 w-4" />Proponi uno scambio</Button>
      </div>

      <div className="my-4 flex items-start gap-2 rounded-lg border border-[#2A3655] bg-[#1C2640] p-3 text-sm text-[#CBD5E1]"><Info className="mt-0.5 h-4 w-4 shrink-0 text-[#2DD4BF]" />{data.note}</div>

      <div className="grid gap-4 md:grid-cols-2">
        <Column title="Puoi dare" tone="#2DD4BF" items={data.you_can_give} />
        <Column title="Puoi ricevere" tone="#7C3AED" items={data.you_can_receive} />
      </div>

      <ProposalComposer open={open} onOpenChange={setOpen} toUserId={data.user.id} toUsername={data.user.username}
        presetGive={data.you_can_give.map((a) => a.id)} presetReceive={data.you_can_receive.map((a) => a.id)} onSent={() => {}} />
    </div>
  );
}
